module.exports = __webpack_public_path__ + "static/media/greenB.e44f0c95.svg";